/**
 * Rebrand logo default fill from brand artwork.
 * TODO: promote into design tokens / palette once Design System adds this colour
 * (not currently in `primitiveColours` or semantic palette).
 */
export const REBRAND_LOGO_FILL = '#0F464F'
